import  { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { PregnancyCalculate_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import { PregnancyTable } from "./Tables"
import { CycleLengthComponent } from './Component';
import SharedHelmet from "../Helmet";
const TITLE = 'Pregnancy Calculator - Calculate Pregnancy and Due Date';
const DESCRIPTION = 'The pregnancy and birth calculator calculates the expected due date based on the Gregorian or Hijri calendar.';
const KEYWORDS = 'Pregnancy Calculator, Expected Due Date Calculator, Gregorian and Hijri Pregnancy Calculation';
const OG_URL = 'https://do-calculate.com/calculator/en/pregnancy/';
const apiEndpoint = `${SERVER_URL}/${PregnancyCalculate_EndPoint}`;
function OvulationCalculator() {
    const [firstDayOfLastPeriod, setFirstDate] = useState();
    const [cycleLength, setCyrcleLength] = useState(28);
    const [result, setRestul] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const handleDateChange = (event) => {
        setFirstDate(event.target.value)
    };
    const calculatePregnancy = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ firstDayOfLastPeriod, cycleLength}),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
            } else {
                setRestul(null);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px', }}>
                        <h1 style={{ fontSize: '15px' }}> Pregnancy Calculator - Calculate Pregnancy and Due Date </h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                Use this tool to calculate pregnancy developments.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className='col-12 col-md-5 calculatorStyle'>
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '15px' }}> Calculate Pregnancy Due Date </h2>
                                </div>
                                <hr />
                                <br />
                                <div className=" form-group d-flex align-items-center">
                                    <b>  <label className="form-label ms-2" >
                                        <strong>First day</strong> of last menstrual cycle:
                                    </label>
                                    </b>
                                    <br />
                                    <input
                                        type="date"
                                        id="weightNumber"
                                        value={firstDayOfLastPeriod}
                                        onChange={handleDateChange}
                                        className="form-control"
                                        style={{ width: '145px' }}
                                        placeholder="175"
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>  <label htmlFor="CycleLength" className="form-label ms-2">
                                        Average time between cycles
                                    </label>
                                    </b>
                                    <CycleLengthComponent handleDateChange={setCyrcleLength} />
                                    <div className="input-group-append">
                                        <span className="input-group-text ">day</span>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <div>
                                    <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                        calculatePregnancy} disabled={isLoading}>
                                        {isLoading ? (
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        ) : (
                                            'Calculate'
                                        )}
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> An error occurred:</u></b> Please enter all fields correctly. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">Results: </div></h4>
                                            <hr />
                                            <PregnancyTable result={result}></PregnancyTable>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.womenCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Pregnancy Calculator Description:</div>
                            <div className="info-section-body">
                                <h2 style={{ fontSize: '15px' }}><u><b>Pregnancy Duration and Expected Due Date:</b></u></h2>
                                <p>
                                    Pregnancy is the term used to describe a woman's condition during a period of approximately 9 months, during which one or more fetuses develop inside the woman. Typically, childbirth occurs after about 38 weeks of fertilization, or about 40 weeks after the last menstrual period. The World Health Organization defines the normal pregnancy period as between 37 and 42 weeks. During the first visit to an obstetrician-gynecologist, the doctor usually provides an estimated due date (based on ultrasound) for the baby's birth, also known as the due date. Alternatively, the due date can also be estimated based on the person's last menstrual period.<br />
                                    While the due date can be estimated, the actual duration of pregnancy depends on multiple factors, including age, length of previous pregnancies, and the mother's weight at birth. However, there are more factors that affect the natural variation in pregnancy duration that are not well understood. Studies have shown that less than 4% of births occur on the specified due date, 60% occur within a week of the due date, and nearly 90% occur within two weeks of the due date. Therefore, while it is possible to have some confidence that a person's baby will be born in about two weeks from the due date, it is not guaranteed.
                                </p>
                                <hr />
                                <h3 style={{ fontSize: '15px' }}><u><b>Pregnancy Detection:</b></u></h3>
                                <p>
                                    Pregnancy can be detected either by using pregnancy tests or by women themselves by observing a number of symptoms, including the absence of the menstrual period, an increase in basal body temperature, fatigue, nausea, and increased urination.
                                    Pregnancy tests include the detection of hormones that act as vital signs of pregnancy. Clinical blood or urine tests can detect pregnancy from six to eight days after fertilization. While clinical blood tests are more accurate and can detect precise amounts of the pregnancy hormone (which is present only during pregnancy) earlier and in smaller amounts, they take longer to evaluate and are more expensive than home pregnancy tests. Clinical urine tests are also available, but these tests are not necessarily more accurate than home pregnancy tests and can be more expensive as well.
                                </p>
                                <hr />
                                <h3 style={{ fontSize: '15px' }}><u><b>Pregnancy Management:</b></u></h3>
                                <p>
                                    There are several factors to consider during pregnancy, many of which depend heavily on each individual's condition, such as medications, weight gain, physical activity, and nutrition.
                                </p>
                                <hr />
                                <h3 style={{ fontSize: '15px' }}><u><b>Medications:</b></u></h3>
                                <p>
                                    Taking certain medications during pregnancy can have permanent effects on the fetus. In the United States, drugs are classified into categories A, B, C, D, and X by the Food and Drug Administration (FDA) based on the potential benefits versus fetal risks. Drugs that carry positive benefits for the mother and low risks to the fetus are classified as category A, while drugs with established and significant fetal risks that outweigh potential benefits to the mother are classified as category X. Pregnant individuals should consult their doctor about any medications they plan to use during pregnancy.
                                </p>
                                <hr />
                                <b>Last Review Date:</b> 08/07/2023
                            </div>
                        </div>
                    </div>
                    <br />
                    <u><h2>Frequently Asked Questions</h2></u>
                    <br />
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>When Can You Take a Pregnancy Test?</h3>
                            </div>
                            <div className="info-section-body">
                                Some home pregnancy tests claim that you can use them even before the missed first menstrual period, but they will be more accurate if you wait until the first day of the missed menstrual period. Your body does not start producing the pregnancy hormone hCG (human chorionic gonadotropin) until about ten days after fertilization. Professionals recommend that the earlier the test is performed, the more difficult it is for the test to detect the presence of hCG hormone. If your menstrual cycle is irregular, you can take the test about three weeks after unprotected intercourse.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Accurate Are Pregnancy Tests?</h3>
                            </div>
                            <div className="info-section-body">
                                Pregnancy tests, whether done at home or at a doctor's office, are considered to be approximately 99 percent accurate. If you have a positive result, you should contact your doctor to schedule prenatal care. If the pregnancy test is negative, you may have taken it too early. Take another test after a few days. Contact your doctor if it remains negative and you have not had your menstrual period. They can perform a blood test to confirm.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>When Do Pregnancy Symptoms Start?</h3>
                            </div>
                            <div className="info-section-body">
                                Pregnancy symptoms can begin very early, as early as five weeks from pregnancy or about a week after missing your first menstrual period. Common early signs include nausea, breast tenderness, increased urination, and fatigue. Most women experience symptoms around the eighth week of pregnancy.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Why Do Pregnant Women Feel Tired?</h3>
                            </div>
                            <div className="info-section-body">
                                Feeling extremely tired to the point of wanting to rush to bed and stay there all day can be one of the earliest signs of pregnancy. You can blame it on pregnancy hormones, specifically the increased level of progesterone in the first trimester of pregnancy. Pregnancy can also lead to low blood pressure and blood sugar levels, which can make you feel tired. The good news is that your energy is supposed to improve once you enter the second trimester.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Are Cramps Normal During Pregnancy?</h3>
                            </div>
                            <div className="info-section-body">
                                You may experience cramps very early during pregnancy, even before you realize you are pregnant, due to the implantation of the embryo in your uterus. However, you may also notice some cramping in the first trimester. These cramps can occur during exercise or sudden movements, such as flipping in bed. They are caused by cramps in the uterine ligaments and/or irritation of nearby nerve fibers. They should naturally disappear. Inform your doctor immediately if the cramps persist or worsen, as they may indicate an ectopic pregnancy.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>When Does the Baby Bump Start to Show During Pregnancy?</h3>
                            </div>
                            <div className="info-section-body">
                                Every woman is different, but most start to show a noticeable belly around weeks 16-20 of pregnancy. If they have had previous pregnancies, they may show "clearly" earlier.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>When Do Food Cravings Start During Pregnancy?</h3>
                            </div>
                            <div className="info-section-body">
                                Reports suggest that up to 90 percent of all American women suffer from unusual food cravings during pregnancy, with about ¾ experiencing them by the thirteenth week of pregnancy. Chocolate tops the list, followed by high-calorie carbohydrates like pizza and chips, and animal proteins like chicken and meat slices in the third place.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Which Part of the Breast Hurts Early in Pregnancy?</h3>
                            </div>
                            <div className="info-section-body">
                                There is no specific part of the breast that hurts more than others, although you may notice increased sensitivity and pain around the breast nipples. You may feel that your breasts have become fuller or heavier, and you may even feel a slight tingling.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default OvulationCalculator;
